import { round_ex } from "@datanac/datanac-api-toolkit/dist/utility/Math.js";

/**
 * Projected price = board price + crop basis. Returns 0 when there is no board
 * price to derive from, since projected_price is money NOT NULL in the DB.
 */
export const deriveProjectedPrice = (boardPrice, basis) =>
  boardPrice == null ? 0 : round_ex(Number(boardPrice) + (Number(basis) || 0), 4);

/** Crop cards/reports read stored projected_price; persist derived board+basis when they differ. */
export const shouldPersistDerivedProjectedPrice = (storedPrice, derivedPrice) =>
  Number(storedPrice) !== Number(derivedPrice);

/**
 * Unit price for unsold production in marketing / revenue dashboard math.
 * Board crops: market_last_price + crop-profile basis.
 * No-board crops (Sweet Corn, etc.): budget projected_price as-is (already the
 * expected cash price from the budget workaround; do not add basis again).
 */
export const resolveUnsoldUnitPrice = (marketLastPrice, cropProfileBasis, budgetProjectedPrice) => {
  const board =
    marketLastPrice == null || marketLastPrice === "" ? null : Number(marketLastPrice);
  if (board != null && Number.isFinite(board) && board !== 0) {
    return board + (Number(cropProfileBasis) || 0);
  }
  return Number(budgetProjectedPrice) || 0;
};
